(() => {
  if (customElements.get('tw-product-ar')) return;
  let features;
  const timeout = (promise, ms = 20000) => new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('Timeout')), ms);
    promise.then(value => { clearTimeout(timer); resolve(value); }, error => { clearTimeout(timer); reject(error); });
  });
  const loadFeatures = url => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (!features) features = timeout(import(url).then(() => customElements.whenDefined('model-viewer')))
      .catch(error => { features = null; throw error; });
    return features;
  };
  class ProductAR extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.section = this.closest('.sl-enhanced-product');
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-ar-open]');
      this.launch = this.querySelector('[data-shopify-xr]');
      this.status = this.querySelector('[data-ar-status]');
      this.retry = this.querySelector('[data-ar-retry]');
      this.openButton.addEventListener('click', () => {
        this.syncVariant();
        if (this.hidden) return;
        this.dialog.showModal();
        this.event('pdp_ar_open');
        this.load();
      });
      this.querySelector('[data-ar-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => { if (!this.hidden) this.openButton.focus(); });
      this.retry.addEventListener('click', () => this.load());
      this.launch.addEventListener('click', () => { if (!this.launch.disabled) this.event('pdp_ar_launch'); });
      this.onChange = () => queueMicrotask(() => this.syncVariant());
      this.section?.addEventListener('change', this.onChange);
      this.section?.addEventListener('tw:variant-change', this.onChange);
      this.syncVariant();
    }
    syncVariant() {
      const variant = this.section?.querySelector('.sl-product-variant-select')?.value || this.section?.querySelector('form[action*="/cart/add"] [name="id"]')?.value || this.dataset.initialVariant;
      this.hidden = String(variant) !== this.dataset.variant;
      if (this.hidden && this.dialog.open) this.dialog.close();
    }
    event(name) {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      if (!Array.isArray(window.dataLayer)) return;
      window.dataLayer.push({ event: name, product_id: this.section.dataset.productId, variant_id: this.dataset.variant, model_kind: this.dataset.key === 'bike' ? 'simplified' : 'cad' });
    }
    setupXR(model) {
      return timeout(new Promise((resolve, reject) => {
        const setup = () => {
          if (!window.ShopifyXR) { document.addEventListener('shopify_xr_initialized', setup, { once: true }); return; }
          try {
            this.launch.dataset.shopifyModel3dId = String(model.id);
            ShopifyXR.addModels([model]);
            ShopifyXR.setupXRElements();
            this.launch.disabled = false;
            resolve();
          } catch (error) { reject(error); }
        };
        Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: error => error ? reject(error) : setup() }]);
      }));
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      this.retry.hidden = true;
      this.launch.disabled = true;
      this.status.textContent = this.dataset.loading;
      const holder = this.querySelector('[data-ar-viewer]');
      holder.replaceChildren();
      try {
        const response = await fetch(this.dataset.models, { signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('Model catalogue unavailable');
        const model = (await response.json())[this.dataset.key];
        if (!model || model.variant !== this.dataset.variant) throw new Error('Variant mismatch');
        await loadFeatures(this.dataset.viewer);
        const viewer = document.createElement('model-viewer');
        viewer.setAttribute('camera-controls', '');
        viewer.setAttribute('touch-action', 'pan-y');
        viewer.setAttribute('alt', model.alt);
        viewer.setAttribute('shadow-intensity', '0.6');
        viewer.setAttribute('interaction-prompt', 'none');
        const ready = timeout(new Promise((resolve, reject) => {
          viewer.addEventListener('load', resolve, { once: true });
          viewer.addEventListener('error', reject, { once: true });
        }), 30000);
        viewer.src = model.glb;
        holder.append(viewer);
        await ready;
        await this.setupXR(model);
        this.loaded = true;
        this.status.textContent = this.dataset.ready;
        this.event('pdp_ar_model_ready');
      } catch (error) {
        this.lastError = String(error.message || error);
        this.status.textContent = this.dataset.error;
        this.retry.hidden = false;
        this.launch.disabled = true;
        this.event('pdp_ar_error');
      } finally { this.loading = false; }
    }
  }
  customElements.define('tw-product-ar', ProductAR);
})();
